import React, { Component } from "react";

function HomeMap() {
    return (
<>
<iframe width="560" height="315" src="https://webfliessolution.in/map.html" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>


</>
          );
}
export default HomeMap